import { LoginDTO } from "../../../../requests/login/types";
import { AError } from "../../../../requests/types";
import {
  REQUEST_ACTIVE_DIRECTORY_LOGIN,
  LOGIN_ACTIVE_DIRECTORY_SUCCESS,
  LOGIN_ACTIVE_DIRECTORY_ERROR,
} from "../../actions";

// ----- REQUEST ----------------------------------------------------------
type RequestActiveDirectoryLogin = {
  type: typeof REQUEST_ACTIVE_DIRECTORY_LOGIN;
};

export const requestLogin = (): RequestActiveDirectoryLogin => ({
  type: REQUEST_ACTIVE_DIRECTORY_LOGIN,
});

// ----- SUCCESS ---------------------------------------------------------
type SuccessActiveDirectoryLogin = {
  type: typeof LOGIN_ACTIVE_DIRECTORY_SUCCESS;
  payload: {
    data: LoginDTO;
    isUserAdmin: boolean;
  };
};

export const successLogin = (
  data: LoginDTO,
  isUserAdmin: boolean
): SuccessActiveDirectoryLogin => ({
  type: LOGIN_ACTIVE_DIRECTORY_SUCCESS,
  payload: { data, isUserAdmin },
});

// ----- ERROR -----------------------------------------------------------
type ErrorActiveDirectoryLogin = {
  type: typeof LOGIN_ACTIVE_DIRECTORY_ERROR;
  errors: AError;
};

export const errorLogin = (error: AError): ErrorActiveDirectoryLogin => ({
  type: LOGIN_ACTIVE_DIRECTORY_ERROR,
  errors: error,
});

export type ActiveDirectoryLoginActions =
  | RequestActiveDirectoryLogin
  | SuccessActiveDirectoryLogin
  | ErrorActiveDirectoryLogin;
